import { createContext } from "react";
import ChallengeDto from "../../dto/ChallengeDto";
import { IdeiaDto } from "../../dto/IdeiaDto";
import { ResponseUseTermDto } from "../../dto/ResponseUseTermDto";

export interface SelectionContextData {
  challenge: ChallengeDto;
  setChallenge: React.Dispatch<React.SetStateAction<ChallengeDto>>;
  idea: IdeiaDto;
  setIdea: React.Dispatch<React.SetStateAction<IdeiaDto>>;
  stageId: number;
  setStageId: React.Dispatch<React.SetStateAction<number>>;
  categoryId: number;
  setCategoryId: React.Dispatch<React.SetStateAction<number>>;
  tenantId: number;
  setTenantId: React.Dispatch<React.SetStateAction<number>>;
  profileId: number;
  setProfileId: React.Dispatch<React.SetStateAction<number>>;
  clearAll(): void;
  openCreateIdeaModal: boolean;
  setOpenCreateIdeaModal: React.Dispatch<React.SetStateAction<boolean>>;
  useTermModal: boolean;
  setUseTermModal: React.Dispatch<React.SetStateAction<boolean>>;
  useTerm: ResponseUseTermDto;
  setUseTerm: React.Dispatch<React.SetStateAction<ResponseUseTermDto>>;
  mobileMenuOpen: boolean;
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  administrationActiveMenu: string;
  setAdministrationActiveMenu: React.Dispatch<React.SetStateAction<string>>;
  handleLogout: () => void;
  openIdeasModal: boolean;
  setOpenIdeasModal: React.Dispatch<React.SetStateAction<boolean>>;
  tenantName: string;
  setTenantName: React.Dispatch<React.SetStateAction<string>>;
  isMultiTenantOpen: boolean;
  setIsMultiTenantOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refreshPermissions: () => Promise<void>;
}

const SelectionContext = createContext<SelectionContextData>({} as SelectionContextData);

export default SelectionContext;